module.exports = __webpack_public_path__ + "media/images/landing_page/13-9ea9a5ba67987371d24b353dbd3491db.webp";